import actionTypes from '../constants/action-types';

const setTemplatesData = (templatesData) => ({
  type: actionTypes.SET_DATA,
  payload: { templatesData },
});

export default setTemplatesData;
